/* TRAPT v0.9.8.7.8.0.6 — product page: sticky buy bar, size dimensions in the legend,
   and a rating badge that jumps to the reviews. */
(() => {
  const onReady = (fn) => {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ---------- Sticky bar ---------- */
  const setupSticky = (root) => {
    const bar = root.querySelector('[data-sticky-atc]');
    const info = root.querySelector('product-info') || root;
    const submit = info.querySelector('.product-form__submit');
    const target = info.querySelector('variant-selects, .product-form__input, .t98731-bundle') || submit;
    if (!bar || !submit || bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';

    const show = (state) => {
      bar.hidden = !state;
      bar.classList.toggle('is-visible', state);
      document.body.classList.toggle('t9806-has-sticky', state);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        // Only once the button has gone past the top of the screen, never before the page has moved.
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { rootMargin: '0px 0px -60% 0px', threshold: 0 });
      observer.observe(submit);
    }

    bar.querySelector('[data-sticky-atc-button]')?.addEventListener('click', () => {
      const anchor = target || submit;
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const firstOption = info.querySelector('.product-form__input input[type="radio"]:checked, .t98731-bundle__tier.is-selected');
      if (firstOption && typeof firstOption.focus === 'function') {
        window.setTimeout(() => firstOption.focus({ preventScroll: true }), 420);
      }
    });

  };

  /* ---------- "Size: Small 24 x 33 cm" ---------- */
  const setupSizeDims = (root) => {
    root.querySelectorAll('[data-selected-dim]').forEach((slot) => {
      const fieldset = slot.closest('fieldset, .product-form__input');
      if (!fieldset) return;
      const paint = () => {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        slot.textContent = checked?.dataset.sizeDim ? ` ${checked.dataset.sizeDim}` : '';
      };
      fieldset.addEventListener('change', paint);
      paint();
    });
  };

  /* ---------- Rating badge jumps to the reviews ---------- */
  const setupRatingLink = (root) => {
    const badge = root.querySelector('.jdgm-preview-badge, [data-trapt-rating]');
    if (!badge || badge.dataset.traptLinked === 'true') return;
    const reviews = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widget, .jdgm-review-widget, [id*="shopify-block"] .jdgm-widget:not(.jdgm-preview-badge)');
    if (!reviews) return;
    badge.dataset.traptLinked = 'true';
    badge.classList.add('t9806-rating-link');
    badge.setAttribute('role', 'link');
    badge.setAttribute('tabindex', '0');
    badge.setAttribute('title', 'Read the reviews');
    const jump = () => reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    badge.addEventListener('click', (event) => {
      event.preventDefault();
      jump();
    });
    badge.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        jump();
      }
    });
  };

  const init = (root = document) => {
    setupSticky(root);
    setupSizeDims(root);
    setupRatingLink(root);
  };

  onReady(() => {
    init();
    // Judge.me paints its widgets late.
    window.setTimeout(() => setupRatingLink(document), 1200);
    window.setTimeout(() => setupRatingLink(document), 3000);
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
